import {toast} from "react-toastify";
import useThemeStore from "../../store/theme";

const mode = useThemeStore.getState().mode;
const defaultProps = {
    rtl: true,
    theme: mode,
};

export default {
    info: (content, options) => toast.info(content, options ? {...defaultProps, ...options} : {...defaultProps}),
    error: (content, options) => toast.error(content, options ? {...defaultProps, ...options} : {...defaultProps}),
    success: (content, options) => toast.success(content, options ? {...defaultProps, ...options} : {...defaultProps}),
    warning: (content, options) => toast.warning(content, options ? {...defaultProps, ...options} : {...defaultProps}),
    default: (content, options) => toast(content, options ? {...defaultProps, ...options} : {...defaultProps}),
}